import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { ItemPopupProps } from "../../../types/PopupProps";
import { DataResult } from "../../../types/Result";

interface ItemBrandModel {
    itemId: number
    brandId: number
}

const AddBrandPopup: React.FC<ItemPopupProps> = ({ show, onHide, itemId }) => {
    const [serverErrors, setServerErrors] = useState<DataResult<ItemBrandModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();

    const brands = useSelectListOptions('api/v1/selectlist/BrandNameTrees?activeOnly=true', '-- Select brand');

    const [formData, setFormData] = useState<ItemBrandModel>({
        itemId: itemId,
        brandId: 0
    });

    function submit() {
        if (formData) {
            DataService
                .create<ItemBrandModel>(`api/v1/ItemBrands`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'brandId', label: 'Brand', labelSize: 2, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add brand'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('brandId')} options={brands} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton {...getSubmitButtonProps()} text='Add' />
            </Popup.Footer>
        </Popup>
    );
}
export default AddBrandPopup;